import ConfirmChangeEmail from './ConfirmChangeEmail.async';

export default ConfirmChangeEmail;